import parse from 'html-react-parser';
import { BRAND_CODES } from '../brand';

export const parseHtml = (html: string) => {
  return parse(html);
};

export const setPageTitle = (stateCode?: string, brandCode?: string) => {
  document.title = getPageTitle(stateCode, brandCode);
};

const getPageTitle = (stateCode?: string, brandCode?: string) => {
  // Check brand first if specified
  if (brandCode === BRAND_CODES.HEALTHSPRING) {
    return 'Member Payment Portal | HealthSpring';
  }

  // Fall back to state-based titles (BCBS brand)
  switch (stateCode?.toLowerCase()) {
    case 'il':
      return 'Member Payment Portal | Blue Cross and Blue Shield of Illinois';
    case 'tx':
      return 'Member Payment Portal | Blue Cross and Blue Shield of Texas';
    case 'mt':
      return 'Member Payment Portal | Blue Cross and Blue Shield of Montana';
    case 'nm':
      return 'Member Payment Portal | Blue Cross and Blue Shield of New Mexico';
    case 'ok':
      return 'Member Payment Portal | Blue Cross and Blue Shield of Oklahoma';
    default:
      return 'Member Payment Portal | Blue Cross and Blue Shield';
  }
};
